<template>
  <div class="inspection-page">
    <div class="left-form" ref="madeForm">
      <avue-form ref="AvueForm" :option="formOption" v-model="detailForm" @submit="submit"></avue-form>
      
      <!-- 储备点信息表格 -->
      <div class="storage-point-section">
        <div class="section-title">
          <span>储备点信息</span>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addStoragePoint">添加储备点</el-button>
        </div>
        <el-table :data="storagePointList" border style="width: 100%" v-if="storagePointList.length > 0">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="储备点" prop="storagePointName" min-width="200">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.storagePointId"
                placeholder="请选择储备点"
                filterable
                style="width: 100%"
                @change="handleStoragePointChange(scope.row, $event)"
              >
                <el-option
                  v-for="item in storagePointOptions"
                  :key="item.id"
                  :label="item.pointName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="实际入库数量" prop="actualQuantity" min-width="150">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.actualQuantity"
                :min="1"
                :max="999999"
                :precision="0"
                style="width: 100%"
                @change="calculateTotalQuantity"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeStoragePoint(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="empty-tip">请添加至少一个储备点</div>
      </div>
    </div>
  </div>
</template>

<script>
import { disposeDetail, rulesInput } from '@/basic-common/util/common.js';
import { getList as getMaterialList } from '../api';
import { getList as getStoragePointList } from '../../reserve-point/api';
import { add as addStockin } from '../../emergency-entry-record/api';

export default {
  data () {
    return {
      detailForm: {
        inBatchNo: '',
        materialCode: '',
        materialName: '',
        materialType: '',
        purchaseDate: '',
        expiryDate: '',
        specModel: '',
        totalQuantity: 0,
        unit: '',
        remark: ''
      },
      storagePointList: [],
      storagePointOptions: [],
      materialOptions: [],
      formOption: {
        ...this.$store.state.formOption,
        menu: false,
        span: 24,
        submitBtn: true,
        emptyBtn: true,
        edit: true,
        column: [
          {
            label: '入库批号',
            prop: 'inBatchNo',
            type: 'input',
            maxlength: 100,
            placeholder: '请输入入库批号',
            rules: rulesInput(1),
            span: 12,
          },
          {
            label: '物资编码',
            prop: 'materialCode',
            type: 'select',
            dicData: [],
            placeholder: '请选择物资',
            rules: rulesInput(1),
            span: 12,
            props: {
              label: 'label',
              value: 'value',
            },
            change: ({value}) => {
              this.handleMaterialChange(value);
            },
          },
          {
            label: '物资名称',
            prop: 'materialName',
            type: 'input',
            disabled: true,
            span: 12,
          },
          {
            label: '物资类型',
            prop: 'materialType',
            type: 'select',
            dicData: [
              { label: '防护用品', value: '1' },
              { label: '救援设备', value: '2' },
              { label: '医疗用品', value: '3' },
              { label: '通讯设备', value: '4' },
              { label: '消防器材', value: '5' },
              { label: '食品饮料', value: '6' },
              { label: '其他物资', value: '7' },
            ],
            disabled: true,
            span: 12,
          },
          {
            label: '采购日期',
            prop: 'purchaseDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: rulesInput(1),
            span: 12,
          },
          {
            label: '有效期至',
            prop: 'expiryDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: rulesInput(1),
            span: 12,
          },
          {
            label: '规格型号',
            prop: 'specModel',
            type: 'input',
            maxlength: 100,
            placeholder: '请输入规格型号',
            span: 12,
          },
          {
            label: '总入库数量',
            prop: 'totalQuantity',
            type: 'number',
            precision: 0,
            min: 0,
            disabled: true,
            span: 12,
          },
          {
            label: '数量单位',
            prop: 'unit',
            type: 'select',
            dicData: [
              { label: '个', value: '1' },
              { label: '台', value: '2' },
              { label: '套', value: '3' },
              { label: '件', value: '4' },
              { label: '箱', value: '5' },
              { label: '包', value: '6' },
              { label: '瓶', value: '7' },
              { label: '盒', value: '8' },
              { label: '吨', value: '9' },
              { label: '公斤', value: '10' },
              { label: '升', value: '11' },
              { label: '米', value: '12' },
              { label: '其他', value: '13' },
            ],
            rules: rulesInput(1),
            span: 12,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 500,
            rows: 4,
            placeholder: '请输入备注',
            span: 24,
          },
        ],
      },
    };
  },
  mounted () {
    this.init();
    this.loadMaterialOptions();
    this.loadStoragePointOptions();
  },
  methods: {
    init () {
      disposeDetail(this.$refs.madeForm);
    },
    // 加载物资选项
    async loadMaterialOptions () {
      try {
        const res = await getMaterialList({
          page: 1,
          size: 1000,
          status: 1, // 只获取有效的物资
        });
        if (res.data && res.data.data && res.data.data.records) {
          this.materialOptions = res.data.data.records;
          const materialColumn = this.formOption.column.find(col => col.prop === 'materialCode');
          if (materialColumn) {
            materialColumn.dicData = this.materialOptions.map(item => ({
              label: `${item.materialName} (${item.materialCode})`,
              value: item.materialCode,
              ...item
            }));
          }
        }
      } catch (error) {
        console.error('加载物资列表失败:', error);
        this.$message.error('加载物资列表失败');
      }
    },
    // 加载储备点选项
    async loadStoragePointOptions () {
      try {
        const res = await getStoragePointList({
          page: 1,
          size: 1000,
          status: 1, // 只获取有效的储备点
        });
        if (res.data && res.data.data && res.data.data.records) {
          this.storagePointOptions = res.data.data.records.map(item => ({
            id: item.id,
            pointName: item.pointName,
          }));
        }
      } catch (error) {
        console.error('加载储备点列表失败:', error);
        this.$message.error('加载储备点列表失败');
      }
    },
    // 处理物资选择变化
    handleMaterialChange (materialCode) {
      // materialCode就是dicData中的value
      const material = this.materialOptions.find(item => item.materialCode === materialCode);
      if (material) {
        this.detailForm.materialName = material.materialName;
        this.detailForm.materialType = material.materialType;
        this.detailForm.unit = material.unit || '';
        // 更新储备点列表的单位
        this.storagePointList.forEach(item => {
          item.unit = material.unit || '';
        });
      }
    },
    // 添加储备点
    addStoragePoint () {
      this.storagePointList.push({
        storagePointId: '',
        storagePointName: '',
        actualQuantity: 1,
        unit: this.detailForm.unit || '',
      });
    },
    // 移除储备点
    removeStoragePoint (index) {
      this.storagePointList.splice(index, 1);
      this.calculateTotalQuantity();
    },
    // 处理储备点选择变化
    handleStoragePointChange (row, storagePointId) {
      const storagePoint = this.storagePointOptions.find(item => item.id === storagePointId);
      if (storagePoint) {
        row.storagePointName = storagePoint.pointName;
      }
    },
    // 计算总入库数量
    calculateTotalQuantity () {
      const total = this.storagePointList.reduce((sum, item) => {
        return sum + (Number(item.actualQuantity) || 0);
      }, 0);
      this.detailForm.totalQuantity = total;
    },
    // 提交表单
    submit (form, done) {
      this.$refs.AvueForm.validate((valid) => {
        if (!valid) {
          done();
          return false;
        }
        // 验证储备点信息
        if (!this.storagePointList || this.storagePointList.length === 0) {
          this.$message.warning('请至少添加一个储备点');
          done();
          return false;
        }

        // 验证储备点信息完整性
        for (let i = 0; i < this.storagePointList.length; i++) {
          const item = this.storagePointList[i];
          if (!item.storagePointId) {
            this.$message.warning(`请选择第${i + 1}个储备点`);
            done();
            return false;
          }
          if (!item.actualQuantity || item.actualQuantity <= 0) {
            this.$message.warning(`请输入第${i + 1}个储备点的实际入库数量`);
            done();
            return false;
          }
        }

        // 构建提交数据
        const submitData = {
          ...this.detailForm,
          emergencyMSExtList: this.storagePointList.map(item => ({
            storagePointId: item.storagePointId,
            storagePointName: item.storagePointName,
            actualQuantity: item.actualQuantity,
            unit: this.detailForm.unit,
          })),
        };
        console.log(`------submitData`,submitData)

        // 调用接口提交
        addStockin(submitData).then((res) => {
            if (res.data && res.data.code === 200) {
              this.$message.success('入库申请提交成功');
              this.resetForm();
              done();
              this.$emit('success');
            } else {
  
            }
          })
      });
    },
    // 重置表单
    resetForm () {
      this.$refs.AvueForm.resetForm();
      this.detailForm = {
        inBatchNo: '',
        materialCode: '',
        materialName: '',
        materialType: '',
        purchaseDate: '',
        expiryDate: '',
        specModel: '',
        totalQuantity: 0,
        unit: '',
        remark: '',
      };
      this.storagePointList = [];
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu {
  display: none;
}
.inspection-page {
  display: flex;
  padding: 20px;
  gap: 20px;
  background-color: #fff;
}
.left-form {
  flex: 1;
}
.storage-point-section {
  margin-top: 20px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>